import toast from "react-simple-toasts";

function Toast({ text }: any) {
  return (
    <div className="rounded-md bg-gray-200 text-center font-boska font-black py-2 px-3">
      {text}!
    </div>
  );
}

function showToast(text: String) {
  toast(text, {
    time: 2500,
    position: "top-right",
    clickable: false,
    clickClosable: true,
    className: "custom-toast",
    render: (message) => <Toast text={message} />,
  });
}

export default showToast;
